/**
 * Registro
 *
 * @author edmsamuel
 */
import React from 'react'
import { Form, Button, message as Message, Checkbox, Divider, Input } from 'antd'
import Exception from '../Exception'
import Api from '../Api'
import { connect } from 'react-redux'

class RegistroForm extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)
    this.register = this.register.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  /**
   * On Submit
   *
   */
  onSubmit(e) {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.register(values)
      }
    })
  }

  /**
   * Solicita al servidor que se verifiquen las credenciales
   *
   * @param {Object} credentials
   */
  register(credentials) {
    if (credentials.clave !== credentials.confirmacion) {
      return Message.info('Las contraseñas no coincidden')
    }

    const CloseLoading = Message.loading('Registrando', 0)
    Api.post('/com/proveedores', credentials)
      .then(response => {
        CloseLoading()
        Message.success(`Bienvenido ${response.data.sRazonSocial}`)

        if (this.props.onRegisterOk) {
          this.props.onRegisterOk(response.data)
        }
      })
      .catch(error => {
        CloseLoading()
        Message.error((new Exception(error)).toComponent())
      })
  }

  /**
   * Get Field
   *
   * @param {String} name
   */
  getField(name) {
    const options = {
      rfc: {
        rules: [{ required: true, message: 'RFC' }]
      },
      nombrecorto: {
        rules: [{ required: true, message: 'Nombre Corto' }]
      },
      razonsocial: {
        rules: [{ required: true, message: 'Razon Social' }]
      },
      direccion: {
        rules: [{ required: true, message: 'Dirección' }]
      },
      estado: {
        rules: [{ required: true, message: 'Estado' }]
      },
      ciudad: {
        rules: [{ required: true, message: 'Ciudad' }]
      },
      colonia: {
        rules: [{ required: true, message: 'Colonia' }]
      },
      codigopostal: {
        rules: [{ required: true, message: 'Código postal' }]
      },
      clave: {
        rules: [{ required: true, message: 'Contraseña' }]
      },
      confirmacion: {
        rules: [{ required: true, message: 'Confirmación' }]
      },
    }

    switch (name) {
      case 'rfc':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input placeholder='RFC' />
        )

      case 'nombrecorto':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input placeholder='Nombre Corto' />
        )

      case 'razonsocial':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input placeholder='Razón Social' />
        )

      case 'direccion':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input placeholder='Direccion' />
        )

      case 'estado':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input placeholder='Estado' />
        )

      case 'ciudad':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input placeholder='Ciudad' />
        )

      case 'colonia':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input placeholder='Colonia' />
        )

      case 'codigopostal':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input placeholder='Código Postal' />
        )

      case 'proveedornacional':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Checkbox defaultChecked />
        )

      case 'clave':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input
            type='password'
            placeholder='Contraseña'
          />
        )

      case 'confirmacion':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input
            type='password'
            placeholder='Confirmar'
          />
        )

      default:
        return null
    }
  }

  /**
   * Render
   *
   */
  render() {
    const { theme } = this.props

    return (
      <Form onSubmit={this.onSubmit} className='login-form'>
        <div style={{ display: 'flex' }}>
          <Form.Item
            label={<label>RFC</label>}
            style={{marginRight:10}}
            children={this.getField('rfc')}
          />

          <Form.Item
            label={<label>Nombre Corto</label>}
            children={this.getField('nombrecorto')}
            style={{ flex: 1 }}
          />
        </div>

        <div style={{ display: 'flex' }}>
          <Form.Item
            label={<label>Razón Social</label>}
            children={this.getField('razonsocial')}
            style={{ flex: 1 }}
          />
        </div>

        <Divider style={{ background: theme.colors.border }} />

        <div style={{ display: 'flex'}}>
          <Form.Item
            style={{marginRight:10}}
            label={<label>Dirección</label>}
            children={this.getField('direccion')}
          />

          <Form.Item
            style={{marginRight:10}}
            label={<label>Estado</label>}
            children={this.getField('estado')}
          />

          <Form.Item
            label={<label>Ciudad</label>}
            children={this.getField('ciudad')}
          />
        </div>

        <Divider style={{ background: theme.colors.border }} />

        <div style={{ display: 'flex'}}>
          <Form.Item style={{marginRight:15}}
            label={<label>Colonia</label>}
            children={this.getField('colonia')}
          />

          <Form.Item
            style={{marginRight:15}}
            label={<label>Código Postal</label>}
            children={this.getField('codigopostal')}
          />


          <Form.Item
            label={<label>Proveedor Nacional</label>}
            children={this.getField('proveedornacional')}
          />
        </div>

        <div style={{ display: 'flex'}}>
          <Form.Item
            style={{marginRight:15}}
            label={<label>Clave</label>}
            children={this.getField('clave')}
          />

          <Form.Item
            style={{marginRight:15}}
            label={<label>Confirmación</label>}
            children={this.getField('confirmacion')}
          />
        </div>
        <Form.Item>
          <Button type='primary' htmlType='submit' className='login-form-button'>Registrar</Button>
        </Form.Item>
      </Form>
    )
  }
}

const buildStyles = (theme) => ({
  label: {
    marginRight: 5,
    // color: theme.colors.label
  },
})

const connectedComponent = connect(
  state => ({
    theme: state.theme.values,
    styles: buildStyles(state.theme.values)
  })
)(RegistroForm)

const Registro = Form.create()(connectedComponent)
export default Registro
